module.exports = "/images/vendor/flag-icon-css/flags/4x3/bi.svg?06f36479b44476f25fc935175ac8a596";